import React, { useEffect, useRef, useState } from "react";
import { API } from "../api";

// Issuer URL of the realm that protects a RESTRICTED datasource
// (e.g. https://auth.bavaria.need.energy/realms/lod2).
// Prefilled from the OpenAPI document's security schemes when it declares one,
// checked against the issuer's OpenID discovery document when the field loses focus.
export function AuthorizationServerField({ value, onChange, openapiUrl, disabled, inputClassName }) {
  const [status, setStatus] = useState(null); // {ok, message} | null
  const [checking, setChecking] = useState(false);
  const askedFor = useRef(null);

  // Suggest the issuer from the OpenAPI document (once per URL, only if empty).
  useEffect(() => {
    if (value || !openapiUrl || askedFor.current === openapiUrl) return;
    askedFor.current = openapiUrl;
    let cancelled = false;
    API.get("/api/metadata/authorization-server", { params: { openapi_url: openapiUrl } })
      .then((res) => {
        if (cancelled || !res.data?.issuer) return;
        onChange(res.data.issuer);
        setStatus({ ok: true, message: "Taken from the OpenAPI document" });
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [openapiUrl, value, onChange]);

  const check = async () => {
    const issuer = (value || "").trim();
    if (!issuer) { setStatus(null); return; }
    setChecking(true);
    try {
      const res = await API.get("/api/metadata/authorization-server", { params: { issuer } });
      if (res.data?.issuer && res.data.issuer !== issuer) onChange(res.data.issuer);
      setStatus({ ok: !!res.data?.ok, message: res.data?.message || "" });
    } catch {
      setStatus({ ok: false, message: "Could not check the authorization server" });
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="space-y-2">
      <input
        type="url"
        value={value || ""}
        onChange={(e) => { onChange(e.target.value); setStatus(null); }}
        onBlur={check}
        disabled={disabled}
        placeholder="https://auth.example.org/realms/your-realm"
        className={inputClassName}
      />
      <p className="text-xs text-slate-500 leading-relaxed px-1">
        The Keycloak realm (OIDC issuer) that protects your data. NEED uses it to request
        access for users you have approved; no secret is shared.
      </p>
      {checking && <p className="text-xs font-semibold text-slate-500 px-1">Checking…</p>}
      {!checking && status && (
        <p className={`text-xs font-semibold px-1 ${status.ok ? "text-green-600" : "text-red-500"}`}>
          {status.message}
        </p>
      )}
    </div>
  );
}
